import { Translation } from "@shared/types/translation";
import { Locale, useLocale } from "@translations/locale-context";
import { Button } from "@ui/components/button/button";
import jump from "jump.js";

const START_PACKAGE_POINTS: Translation[] = [
    {
        cs: "Úvodní sezení, kde si řekneme, kde vás nejvíce tlačí bota",
        en: "Initial meeting, where we discuss your biggest issues",
    },
    {
        cs: "Vybereme stránky, které náš expert okomentuje",
        en: "We will select the pages that our expert will comment on",
    },
    {
        cs: "Výstup od\u00a0experta na\u00a0použitelnost v\u00a0podobě 10 a\u00a0více stran a\u00a0doporučení míst pro detailní pohled",
        en: "Output from an\u00a0expert on usability in the form of 10 or more pages with recommendations of spots that need a\u00a0detailed look",
    },
];

const en = "Starting usability analysis";
const cs = "Startovní analýza použitelnosti";

const priceEn = "390\xa0EUR";
const priceCs = "9\xa0900\xa0Kč";

const buttonEn = "Request a Quote";
const buttonCs = "Nezávazně poptat";

const headerEn = "You can choose from our UX audit packages";
const headerCs = "Vybrat si můžete z\xa0balíčků našeho UX auditu";

export function StartPackage() {
    const locale: Locale = useLocale();
    const handleClick = () => {
        jump(".contact-section");
    };

    return (
        <div className="audit-packages">
            <h2 className="py-8 text-center text-h5 font-semibold max-md:px-5">
                {locale === "en" ? headerEn : headerCs}
            </h2>
            <div className="grid gap-8 bg-uxfViolet px-3 py-8 text-white md:container max-md:mx-5 md:px-8 md:py-6 lg:grid-cols-[5fr_3fr] xl:grid-cols-[5fr_2fr]">
                <div>
                    <h3 className="pb-4 text-body font-semibold max-md:text-center">{locale === "en" ? en : cs}</h3>
                    <ul className="text-body">
                        {START_PACKAGE_POINTS.map((point, index) => (
                            <li key={index} className="ml-6 list-disc text-[#DBD7E7]">
                                {locale === "en" ? point.en : point.cs}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="content-center text-center">
                    <p className="pb-6 text-medium font-bold max-md:py-6">{locale === "en" ? priceEn : priceCs}</p>
                    <Button variant="orange" size="small" onClick={handleClick}>
                        <p className="px-7">{locale === "en" ? buttonEn : buttonCs}</p>
                    </Button>
                </div>
            </div>
        </div>
    );
}
